import DEVICE_API from '../../api/device'

// initial state
const state = {
	devices: []
}

// getters
const getters = {
	devices: state => state.devices,
	devices_user: state => state.devices.filter(function (item) { return item.groupname.startsWith('test-') })
}

// actions
const actions = {
	getDevices ({ commit }, email) {
		console.log('getDevices Store', email)

		DEVICE_API.get(
			email,
			data => {
				console.log(data)

				commit('setDevices', data)
			}, e => {
				console.log(e)
			}
		)
	},

	getDevicesProduct ({ commit }, product) {
		console.log('getDevicesProduct for product', product)
		/*
    DEVICE_API.get(
      data => {
          console.log(data);

          var boxesFilteredPerProduct = data.filter(function (item) {
            return item.productname === product;
          });

          commit('setDevices', boxesFilteredPerProduct);
      }, e => {
          console.log(e);
      }
    ) */
	},

	addDevice ({ commit }, device) {
		console.log('addDevice in Store')

		commit('addDevice', device)
	},

	deleteDevice ({ commit }, serialnumber) {
		console.log('deleteDevice in Store')

		commit('delete', serialnumber)
	},

	setSoftwareData ({ commit }, softwareData) {
		console.log('setSoftwareData in Store')

		commit('setSoftwareData', softwareData)
	},

	resetDevices ({ commit }) {
		console.log('reset in Store')

		commit('reset')
	},

	updateDevice ({ commit }, device) {
		console.log('reset in Store')

		commit('update', device)
	},

	setDevices ({ commit }, devices) {
		console.log('Set device for user in Store')

		commit('setDevices', devices)
	}
}

// mutations
const mutations = {
	setDevices (state, devices) {
		console.log('set all the devices')
		state.devices = devices
	},

	addDevice (state, device) {
		var key; var keys = Object.keys(device)
		var numKeys = keys.length
		var deviceKeysLowercase = {}
		while (numKeys--) {
			key = keys[numKeys]
			deviceKeysLowercase[key.toLowerCase()] = device[key]
		}

		state.devices.push(deviceKeysLowercase)
	},

	delete (state, serialnumber) {
		for (var index = 0; index < state.devices.length; index++) {
			console.log('')
			if (state.devices[index].serialnumber === serialnumber) {
				state.devices.splice(index, 1)
				break
			}
		}
	},

	setSoftwareData (state, softwareData) {
		console.log('setSoftwareData ', softwareData)

		for (var index = 0; index < state.devices.length; index++) {
			var device = state.devices[index]

			if (device.serialnumber === softwareData.serialnumber) {
				Object.assign(device, softwareData)

				console.log('setSoftwareData FOUND')

				console.log('setSoftwareData FOUND', state.devices[index])

				break
			}
		}
	},

	update (state, device) {
		console.log('update ', device)

		for (var index = 0; index < state.devices.length; index++) {
			var deviceTmp = state.devices[index]

			if (deviceTmp.serialnumber === device.serialnumber) {
				Object.assign(deviceTmp, box)

				break
			}
		}
	},

	reset (state) {
		state.devices = []
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
